import axios from "axios";
import React, { useEffect, useState } from "react";
import index from "react-typical";
// import Banner from "../Course/Banner";
import Header from "../Course/Header";
import Footer from "../Footer";
import "./ListOfStudents.css";
import UpdateIcon from "@material-ui/icons/Update";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

function ListOfStudents() {
  const [listStudents, setListStudents] = useState([]);
  // console.log(localStorage.getItem("Token"));
  // localStorage.getItem("Token");

  useEffect(() => {
    var config = {
      method: "get",
      url: "https://localhost:44300/api/Registration/GetAllRegistrationList",
      headers: {
        Authorization:
          // " Bearer -kmOaBpDRhUr0UjNJQ0MIh85tOnOaBntqpyQCvPuUk-62z9DsrzjKJwZsFS6fdKJqH8l0XHU6uhASxLcG6WAIK9pa_3FitDNq2lKSE1zcgA_6vD7GE6pwpi2LBXT3VLc_Eyjpya87hsfKiG5MG5cHUIsEioeaUM9DSKOeUl0a3LWSNAuwA015pOjszGio51Lr4LK1QNOZn0n4F13lwp24pqLBHF9sDTg5ktzzKvDiFQ",
          `Bearer ${localStorage.getItem("Token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);
        setListStudents(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div>
      <Header />
      <hr
        style={{
          width: "95%",
          marginTop: "-30px",
          marginBottom: "30px",
          height: "2px",
        }}
      />
      {/* <Banner /> */}
      <h1>List of all students </h1>
      <div className="table">
        <table>
          <thead>
            <th style={{ width: "70px" }}>ID</th>
            <th className="table-th">Fullname</th>
            <th className="table-th" style={{ width: "70px" }}>
              Age
            </th>
            <th className="table-th" style={{ width: "200px" }}>
              Occupation
            </th>
            <th className="table-th">Address</th>
            <th className="table-th" style={{ width: "100px" }}>
              Phone Number
            </th>
            <th className="table-th">Email</th>
            <th className="table-th" style={{ width: "120px" }}>
              Course
            </th>
            <th className="table-th" style={{ width: "100px" }}>
              Time
            </th>
            <th className="table-th" style={{ width: "250px" }}>
              Expectation
            </th>
            <th className="table-th" style={{ width: "70px" }}>
              Delete
            </th>
            <th className="table-th" style={{ width: "70px" }}>
              Update
            </th>
          </thead>
          <tbody>
            {listStudents?.map((e, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{e.Fullname}</td>
                <td>{e.Age}</td>
                <td>{e.Occupation}</td>
                <td>{e.Address}</td>
                <td>{e.PhoneNo}</td>
                <td>{e.Email}</td>
                <td>{e.Course}</td>
                <td>{e.Time}</td>
                <td>{e.Expectation}</td>
                <td>
                  <DeleteForeverIcon style={{ color: "red" }} />
                </td>
                <td>
                  <UpdateIcon style={{ color: "green" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer />
    </div>
  );
}

export default ListOfStudents;
